export function resolve<T = string>(value: any, fallback?: T): T | undefined {
  if (value == null) return fallback;

  if (typeof value !== 'object') return value as T;

  if ('Valid' in value) {
    if (!value.Valid) return fallback;

    if ('String' in value)  return (value.String  || fallback) as T;
    if ('Int64' in value)   return value.Int64   as T;
    if ('Int32' in value)   return value.Int32   as T;
    if ('Float64' in value) return value.Float64 as T;
    if ('Bool' in value)    return value.Bool    as T;
    if ('Time' in value)    return value.Time    as T;
  }

  return fallback;
}
export const asString = (value: unknown): string | undefined => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'string') return value || undefined;
  if (typeof value === 'object' && 'String' in (value as object)) {
    const v = value as { String: string; Valid: boolean };
    return v.Valid ? v.String || undefined : undefined;
  }
  return undefined;
};
export const asNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'number') return value;
  if (typeof value === 'object' && 'Int64' in (value as object)) {
    const v = value as { Int64: number; Valid: boolean };
    return v.Valid ? v.Int64 : undefined;
  }
  return undefined;
};